export default __webpack_public_path__ + "static/media/56t.353a1e4f.jpg";